import { defineComponent } from "vue";
import Tuple from "@common/vue/Tuple.vue";
export default defineComponent({
    components: {
        Tuple
    },
    props: {
        title: {
            type: String,
            required: true
        },
        average: {
            type: Number,
            required: true
        },
        median: {
            type: Number,
            required: true
        },
        deviation: {
            type: Number,
            required: true
        }
    }
});
